<template>
  <div>
    <div class="ag__dropdown" :class="{ active: menuIsActive }">
      <div
        class="ag__dropdown__item ag__dropdown__item--active"
        @click="setActiveItem(null, true)"
      >
        <span class="ag__dropdown__item__text">Download</span>
        <span class="ag-icon ag-icon_greyRightArrow"></span>
      </div>
      <div class="ag__dropdown__menu">
        <div class="download-wrapper" v-if="!loading && !file">
          <ul class="ag-horizontal-form">
            <li>
              <span class="bold-text">Format : </span>
              <span class="value form-item">
                <ul class="ag-horizontal-form">
                  <li class="form-group" v-for="(item, i) in types" :key="i">
                    <label :for="item.name">
                      <input
                        type="radio"
                        :id="item.name"
                        :value="item.id"
                        name="DataFormat"
                        v-model="form.DataFormat"
                      />
                      {{ item.name }}
                    </label>
                  </li>
                </ul>
              </span>
            </li>
            <li>
              <span class="bold-text ml-4">Fields : </span>
              <span class="value form-item">
                <ul class="ag-horizontal-form">
                  <li class="form-group">
                    <label for="min">
                      <input
                        type="radio"
                        id="min"
                        value="0"
                        name="Fields"
                        v-model="form.fields"
                      />

                      <span class="ag-tooltip">
                        <div class="d-flex align-items-center">
                          <i class="ag-icon ag-icon_info mr-1"></i> Minumum
                        </div>
                        <div class="bottom">
                          EventId <br />
                          Severity <br />
                          ComputerGuid <br />
                          ComputerName <br />
                          ComputerPolicyVersion <br />
                          ComputerGroup <br />
                          ReportEventDate <br />
                          EventCount <br />
                          User <br />
                          Actor <br />
                          ActorPath <br />
                          Action <br />
                          Target <br />
                          TargetPath
                          <i></i></div
                      ></span>
                    </label>
                    <label for="max">
                      <input
                        type="radio"
                        id="max"
                        value="1"
                        name="Fields"
                        v-model="form.fields"
                      />

                      <span class="ag-tooltip">
                        <div class="d-flex align-items-center">
                          <i class="ag-icon ag-icon_info mr-1"></i> Expanded
                        </div>
                        <div class="bottom">
                          EventId <br />
                          Severity <br />
                          ComputerGuid <br />
                          ComputerName <br />
                          ComputerPolicyVersion <br />
                          ComputerGroup <br />
                          ReportEventDate <br />
                          EventCount <br />
                          User <br />
                          Actor <br />
                          ActorPath <br />
                          Action <br />
                          Target <br />
                          TargetPath <br />
                          ProcessPath <br />
                          PolicyVersion <br />
                          Facility <br />
                          FacilityName <br />
                          EventType <br />
                          Type <br />
                          TypeName <br />
                          Hash <br />
                          LastSeen <br />
                          Result <br />
                          Access <br />
                          ProcessTree
                          <i></i></div
                      ></span>
                    </label>
                  </li>
                </ul>
              </span>
            </li>
            <li>
              <span class="bold-text">Event Limit : </span>
              <span class="value form-item">
                <ul class="ag-horizontal-form">
                  <li class="form-group">
                    <label for="min" style="width: 240px">
                      <Slider
                        :min="1000"
                        :max="100000"
                        :step="1000"
                        style="width: 240px"
                        tooltipPosition="top"
                        :format="format"
                        v-model="form.lineLimit"
                      />
                    </label>
                  </li>
                </ul>
              </span>
            </li>

            <li style="align-items: flex-end; flex-direction: column">
              <span class="value form-item">
                <ul class="ag-horizontal-form">
                  <li class="form-group">
                    <button
                      type="submit"
                      @click="setActiveItem(null, true)"
                      class="ag-button_secondary ag-button border-0 ag-button_radius mr-3"
                    >
                      Close
                    </button>
                    <button
                      type="submit"
                      @click="handleExport()"
                      class="ag-button_primary ag-button border-0 ag-button_radius"
                    >
                      Submit Query
                    </button>
                  </li>
                </ul>
              </span>
            </li>
          </ul>
        </div>
        <div class="download-wrapper" v-if="loading && !file">
          <div class="download-wait">
            <h3>Processing...</h3>
            <p>Please check again in 2-4 min.</p>
          </div>
        </div>
        <div class="download-wrapper" v-if="file">
          <div class="download-wait">
            <h3>File is ready to download...</h3>
            <button
              type="submit"
              @click="downloadExport()"
              class="ag-button_primary ag-button border-0 ag-button_radius"
            >
              Download
            </button>
            <small>File will be available for the next 2 minutes</small>
            <h2 class="mt-2" v-if="countDownText">{{ countDownText }}</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "jspdf-autotable";
import { useStore } from "@/store";
import Slider from "@vueform/slider";
import api from "@/store/axiosAgsc";
import Swal from "sweetalert2";
import moment from "moment";
import EventInspection from "@/helpers/pages/EventInspection";
import { mapGetters } from "vuex";
import { saveAs } from "file-saver";
import { useI18n } from "vue-i18n";
const store = useStore();

export default {
  components: { Slider },
  setup() {
    const { t, locale } = useI18n();
    return { t, locale };
  },
  data() {
    return {
      activeItem: null,
      menuIsActive: false,
      downloadStatus: false,
      loading: false,
      file: null,
      countDownText: null,
      countDownDuration: null,
      form: {
        DataFormat: 0,
        fields: 0,
        lineLimit: 1000,
      },
      types: [
        {
          id: 0,
          name: "JSON",
        },
        {
          id: 1,
          name: "CSV",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["company"]),
    exportStatus() {
      return store.state.general.exportStatus;
    },
  },
  watch: {
    countDownText() {
      if (this.countDownDuration && this.countDownDuration._milliseconds < 0) {
        if (localStorage.getItem("eventFile")) {
          const date = localStorage.getItem("eventFileDate");
          var duration = moment.duration(moment().diff(date));
          var minutes = duration.asMinutes();
          if (minutes < 2) {
            this.file = localStorage.getItem("eventFile");
            this.countDown();
          }
        }
        location.reload();
      }
      if (this.countDownText == "00:00") {
        location.reload();
      }
    },
  },
  mounted() {
    if (localStorage.getItem("eventFile")) {
      const date = localStorage.getItem("eventFileDate");
      var duration = moment.duration(moment().diff(date));
      var minutes = duration.asMinutes();
      if (minutes < 2) {
        this.file = localStorage.getItem("eventFile");
        this.countDown();
      }
    }
  },
  methods: {
    countDown() {
      const date = localStorage.getItem("eventFileDate");
      var ms = moment(date).add(2, "minute").diff(moment());
      var duration = moment.duration(ms, "milliseconds");
      var interval = 500;
      /*eslint-disable*/
      var self = this;
      setInterval(function () {
        duration = moment.duration(
          duration.asMilliseconds() - interval,
          "milliseconds"
        );
        self.countDownText = moment(duration.asMilliseconds()).format("mm:ss");
        self.countDownDuration = duration;
      }, interval);
    },
    handleExport() {
      let formData = EventInspection.readyToUseFilters;
      formData.CompanyGuid = this.company.companyGuid;
      formData.DataFormat = this.form.DataFormat.toString();
      formData.fields = this.form.fields.toString();
      formData.lineLimit = this.form.lineLimit.toString();
      formData.download = true;
      this.loading = true;
      api
        .post("Event/ExportBulkData", formData)
        .then((response) => {
          if (Number(response.status) != 200) {
            Swal.fire("Error", response.Errors, "error");
          } else {
            localStorage.setItem("eventFile", response.data.entityData);
            localStorage.setItem("eventFileDate", moment());
            this.file = response.data.entityData;
            this.countDown();
            this.loading = false;
          }
        })
        .catch((e) => {
          this.loading = false;
          Swal.fire(
            "Error",
            e.Message ? JSON.stringify(e.Message) : this.t("error404"),
            "error"
          );
        });
    },
    downloadExport() {
      api
        .post(`Event/DownloadBulkData?fileName=${this.file}`, null, {
          responseType: "blob",
        })
        .then((response) => {
          if (Number(response.status) != 200) {
            Swal.fire("Error", response.Errors, "error");
          } else {
            try {
              saveAs(response.data, this.file);
            } catch (error) {
              console.log("saveas error", error);
            }
          }
        })
        .catch((e) => {
          console.log(e);
          Swal.fire("Error", JSON.stringify(e.Message), "error");
        });
    },
    format: function (value) {
      return `${Math.round(value / 1000)}K`;
    },
    setActiveItem: function (data, selector) {
      const jQuery = window.jQuery;
      if (!selector) {
        this.activeItem = data;
        this.menuIsActive = false;
      } else {
        jQuery('.ag__dropdown').removeClass('active');
        setTimeout(() => {
          this.menuIsActive = !this.menuIsActive;
        }, 5);
      }
      if (data) this.$emit("onChangeDropdown", data);
    },
    setValue(data) {
      this.activeItem = data;
    },
  },
};
</script>

<!-- <style src="@vueform/slider/themes/default.css"></style> -->
<style lang="scss" scoped>
:root {
  --slider-connect-bg: #164b6c;
  --slider-tooltip-bg: #164b6c;
  --slider-handle-ring-color: #164b6c30;
}

.download-wait {
  text-align: center;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
}

.download-wait h3 {
  color: #174b6c;
  font-size: 21px;
}
.download-wait p {
  color: #174b6c;
  font-size: 16px;
}
.download-wait small {
  color: #174b6c;
  margin-top: 12px;
  font-size: 12px;
}
.download-wait button {
  margin-top: 12px;
}
.download-wrapper {
  background: #fff;
  padding: 12px;
  min-height: 200px;
  box-shadow: 1px 4px 6px 0px rgba(119, 119, 119, 0.42);
}
.ag__dropdown.active .ag__dropdown__menu {
  width: 500px;
  left: -335px;
  height: 800px;
  background: transparent;
  box-shadow: none !important;
}

.ag-horizontal-form {
  list-style: none;
  padding: 0;
  margin: 15px 0;
  flex-wrap: wrap;
  width: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
}

.ag-horizontal-form label {
  font-size: 16px !important;
  display: flex;
  align-items: center;
  margin: 0px;
  margin-right: 12px;
}

.bold-text {
  margin-right: 12px;
}

.ag-horizontal-form.wrap {
  padding-top: 70px;
  justify-content: center;
  align-items: center;
}

.ag-horizontal-form li {
  flex-direction: row;
  display: flex;
  list-style: none;
  margin: 0;
  padding: 12px 15px;
  flex-grow: 1;
  align-items: center;
  justify-content: flex-start;
}

.ag-horizontal-form li .form-group {
  padding: 10px 0px;
}

input[type="radio"] {
  margin-right: 8px;
}
</style>
